import { ProcessLibraryColonne } from './process-parametrage';

export enum ActionSuiviStatut {
  Planifiee = 0,
  Echec = 1,
  Reussi = 2,
}

export interface ActionSuivi {
  id: number;
  nom: string;
  prevision: string | Date | null;
  previsionHeure?: string | null;
  realisation: string | Date | null;
  realisationHeure?: string | null;
  statut: number;
  typeObjet: number;
  idObjet: number;
  automatisation?: number;
  nomFormation?: string | null;
  debut?: string | Date | null;
  fin?: string | Date | null;
  typeTemporel?: ProcessLibraryColonne;
  informations?: string | null;
  idSession: number;
}
